import {
  addDays,
  differenceInDays,
  endOfDay,
  isBefore,
  isEqual,
  parseISO,
  startOfDay,
  subDays,
} from 'date-fns';

export default {
  computed: {
    bufferStartDate() {
      const { sdbuf } = this.$route.query;

      // Rehydrate buffer datepicker when returning from payment
      if (sdbuf && this.billingAddressType === 'OTHER') return true;

      const startDate = typeof this.startDate === 'string'
        ? parseISO(this.startDate)
        : this.startDate;
      const minBufferedStartDate = typeof this.minBufferedStartDate === 'string'
        ? parseISO(this.minBufferedStartDate)
        : this.minBufferedStartDate;
      const isBeforeMinBufferDate = isBefore(startDate, minBufferedStartDate)
        || isEqual(startDate, minBufferedStartDate);

      return (
        this.billingAddressType === 'OTHER'
        && isBeforeMinBufferDate
      );
    },
    minBufferedStartDate() {
      if (this.moverType === 'BUSINESS' && this.showThirdAddressOption) {
        return addDays(this.today, 7);
      }
      return addDays(this.today, 7);
    },
    today() {
      return startOfDay(new Date());
    },
    todayEnd() {
      return endOfDay(new Date());
    },
    minStartDate() {
      return subDays(this.today, 30);
    },
    maxStartDate() {
      return addDays(this.todayEnd, 90);
    },
    minStopDate() {
      const parsedStartDate = this.startDate ? parseISO(this.startDate) : null;
      const sevenDaysFuture = addDays(this.today, 7);
      if (
        parsedStartDate
        && isBefore(parsedStartDate, this.today)
        && Math.abs(differenceInDays(parsedStartDate, sevenDaysFuture)) < 15
      ) {
        return addDays(parsedStartDate, 15);
      }
      if (parsedStartDate && isBefore(parsedStartDate, this.today)) {
        return addDays(this.today, 7);
      }
      return parsedStartDate ? addDays(parsedStartDate, 15) : addDays(this.today, 7);
    },
    maxStopDate() {
      const parsedStartDate = this.startDate ? parseISO(this.startDate) : null;
      return addDays(parsedStartDate || this.todayEnd, 185);
    },
  },
};
